import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelectStoreListQuery } from "src/api/asAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import styled from "styled-components";
import Body from "../common/Body";
import Box from "../common/Box";
import Button from "../common/Button";
import List from "../common/List";
import AsListItem from "./AsListItem";

const AsedDetail = () => {
  const navigate = useNavigate();
  const storeId: any = getPathValue();

  const asList = useSelectStoreListQuery(storeId, { skip: storeId === undefined });

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            A/S 이력
          </Button>
        </div>
      </header>

      <Body>
        <Box pd="0">
          <TitleSet>
            <p>A/S 이력</p>
          </TitleSet>
          <List pd="0 15px 30px">{asList.isSuccess ? <AsListItem data={asList.data} /> : ""}</List>
        </Box>
      </Body>
    </>
  );
};

const TitleSet = styled.div`
  padding: 30px 15px 0;
  > p {
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 2px solid #000;
  }
`;

export default AsedDetail;
